var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#add_svg__clip0_434_2182)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.894.477a.504.504 0 00-.352.287c-.045.097-.041-.21-.041 3.438V7.5H4.2c-3.648 0-3.34-.004-3.437.041a.514.514 0 00-.262.27.53.53 0 000 .375.524.524 0 00.353.304c.041.01.258.01 3.345.013l3.3.002V11.8c0 3.645-.003 3.337.042 3.435a.515.515 0 00.313.277.39.39 0 00.145.016c.08 0 .1-.002.145-.016a.522.522 0 00.346-.369c.01-.04.01-.258.013-3.34l.002-3.298 3.297-.002c3.083-.002 3.3-.003 3.341-.013a.522.522 0 00.369-.346.39.39 0 00.016-.145.39.39 0 00-.016-.145.514.514 0 00-.277-.313c-.098-.045.21-.041-3.435-.041H8.506L8.504 4.2C8.502 1.113 8.5.896 8.49.855a.52.52 0 00-.346-.367.61.61 0 00-.25-.01z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "add_svg__clip0_434_2182"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
}
export default SvgAdd;